export default __webpack_public_path__ + "static/media/2_the inner voice.0df23fcf.jpg";